import { render, staticRenderFns } from "./LiveContent.vue?vue&type=template&id=1fae96e0&scoped=true&"
import script from "./LiveContent.vue?vue&type=script&lang=js&"
export * from "./LiveContent.vue?vue&type=script&lang=js&"
import style0 from "./LiveContent.vue?vue&type=style&index=0&id=1fae96e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae96e0",
  null
  
)

export default component.exports